module.exports = __webpack_public_path__ + "img/water01.a9d9b22d.png";